
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboardContext } from '../components/Context/DashboardContext';
import { startSignalRConnection } from '../services/signalRService';
const Header = () => {
    const didFetch = React.useRef(false);
    const { profile, profileData, dashboardData, dashboard } = useDashboardContext();
    const [isToggled, setIsToggled] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const navigate = useNavigate();

    const handleSignout = () => {
        // Clear user data from localStorage or context
        localStorage.removeItem('token');
        localStorage.removeItem('userType');
        // Navigate to login page
        navigate('/login');
    };
    const getData = async (token) => {
        const dash = await dashboard(); 
       
        setNotifications(dash.notificationList.sort((a, b) => b.id - a.id))
        await profile();
      
    }
    const requestNotificationPermission = () => {
        if (Notification.permission === "default") {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    console.log("Notification permission granted.");
                } else {
                    console.log("Notification permission denied.");
                }
            });
        }
    };

    React.useEffect(() => {
        if (!didFetch.current) {
            getData();
           
            didFetch.current = true; // Mark the API call as done
            requestNotificationPermission();
        }
        startSignalRConnection();
        const body = document.body;
        const mobileNavToggle = document.querySelector('.mobile-nav-toggle');

        if (isToggled) {
            body.classList.add('toggle-sidebar');
            //mobileNavToggle.classList.add('bi-x');
            //mobileNavToggle.classList.remove('bi-list');
        } else {
            body.classList.remove('toggle-sidebar');
            //mobileNavToggle.classList.remove('bi-x');
            //mobileNavToggle.classList.add('bi-list');
        }
    }, [isToggled]);

    const handleToggleSidebar = () => {
        setIsToggled(prevState => !prevState);
    };
    const generateAvatar = (initial) => {
        const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
            <rect width="100%" height="100%" fill="#02176D" /> <!-- Updated with the detected color -->
            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="40" fill="#fff" font-family="Arial">
                ${initial}
            </text>
        </svg>`;
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
    const handleNotificationClick = (notification) => {
        if (notification.type === "branch") {
            navigate(`/edit-branch/${notification.id}/false`);
        } else if (notification.type === "service") {
            navigate(`/editpartnerservice/${notification.id}/false`);
        } else {
            console.log("Unknown notification type:", notification.type);
        }
    };
    // Helper function to calculate "time ago"
    const getTimeAgo = (createdAt) => {
        const now = new Date();
        const createdTime = new Date(createdAt);
        const diffMs = now - createdTime; // Time difference in milliseconds
        const diffMinutes = Math.floor(diffMs / 1000 / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMinutes < 60) {
            return `${diffMinutes} min${diffMinutes !== 1 ? 's' : ''} ago`;
        }
        if (diffHours < 24) {
            return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
        }
        return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    };

    // Function to get the first initial from `firstName`
    const getFirstInitial = (firstName) => {
        return firstName?.charAt(0)?.toUpperCase() || "G"; // Default to 'G' if firstName is missing
    };

    // Generate the profile picture URL
    const profilePictureUrl = profileData?.firstName
        ? generateAvatar(getFirstInitial(profileData.firstName))
        : generateAvatar("G"); // Default to 'G' if profileData or firstName is unavailable

    return (
        <div style={{ direction: "ltr" }}> {profileData && notifications && dashboardData &&<div>
            <header id="header" className="header fixed-top d-flex align-items-center">

                <div className="d-flex align-items-center justify-content-between">
                    <a href="index.html" className="logo-header d-flex align-items-center">
                      <img 
  src="assets/img/Car Chemist Logo-Main.svg" 
  alt="Logo" 
  style={{ height: '30px' }} 
/>


                        
                    </a>
                    <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleSidebar}></i>
                </div>

                <div className="search-bar">
                    <form className="search-form d-flex align-items-center" method="POST" action="#">
                        <input type="text" name="query" placeholder="Search" title="Enter search keyword"></input>
                        <button type="submit" title="Search"><i className="bi bi-search"></i></button>
                    </form>
                </div>

                <nav className="header-nav ms-auto">
                    <ul className="d-flex align-items-center">

                        <li className="nav-item d-block d-lg-none">
                            <a className="nav-link nav-icon search-bar-toggle " href="#">
                                <i className="bi bi-search"></i>
                            </a>
                        </li>

                        <li className="nav-item dropdown">

                            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                                <i className="bi bi-bell"></i>
                                <span className="badge bg-primary badge-number">{dashboardData.notificationList.length}</span>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications" style={{ maxHeight: "400px", overflowY: "auto", position: "relative" }}>
                                <li className="dropdown-header" style={{
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "#fff", // Matches dropdown background color
                                    zIndex: 10,
                                    padding: "10px 15px",
                                }}>
                                    You have {dashboardData.notificationList.length} new notifications
                                    <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>
                                {notifications.map((notification, index) => (
                                    <div>
                                        <li className="notification-item"
                                            onClick={() => handleNotificationClick(notification)}>
                                    <i className="bi bi-exclamation-circle text-success"></i>
                                    <div>
                                                <h6>{notification.type}</h6>
                                                <p>{notification.message}</p>
                                                <p>{getTimeAgo(notification.createdAt)}</p>
                                    </div>
                                </li>
                                
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li></div>
                                ))}

              

                               
                                <li className="dropdown-footer">
                                    <a href="#">Show all notifications</a>
                                </li>

                            </ul>

                        </li>



                        <li className="nav-item dropdown pe-3">

                            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                                {/* Dynamic Profile Picture */}
                                <img src={profilePictureUrl} alt="Profile" className="rounded-circle" />
                                {/* Display First Name */}
                                <span className="d-none d-md-block dropdown-toggle ps-2">
                                    {profileData?.firstName || "Guest"}
                                </span>

                            </a>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                <li className="dropdown-header">
                                    <h6>{profileData.firstName} {profileData.lastName}</h6>
                                    <span>{profileData.userRole}</span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                                        <i className="bi bi-person"></i>
                                        <span>My Profile</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                                        <i className="bi bi-gear"></i>
                                        <span>Account Settings</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="pages-faq.html">
                                        <i className="bi bi-question-circle"></i>
                                        <span>Need Help?</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleSignout}>
                                        <i className="bi bi-box-arrow-right"></i>
                                        <span>Sign Out</span>
                                    </a>
                                </li>

                            </ul>
                        </li>

                    </ul>
                </nav>

            </header>
            <aside id="sidebar" className="sidebar">

                <ul className="sidebar-nav" id="sidebar-nav">

                    <li className="nav-heading">Pages</li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/dashboard">
                            <i className="bi bi-info-circle"></i>
                            <span>Dashboard</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/partner">
                            <i className="bi bi-person"></i>
                            <span>Partners</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/allbranch">
                            <i className="bi bi-person"></i>
                            <span>Branch</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="pages-contact.html">
                            <i className="bi bi-person"></i>
                            <span>Customers</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/partnerservice">
                            <i className="bi bi-card-list"></i>
                            <span>Partner's Service</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/products">
                            <i className="bi bi-card-list"></i>
                            <span>Products</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/viewpackage">
                            <i className="bi bi-person"></i>
                            <span>Packages</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/orders">
                            <i className="bi bi-card-list"></i>
                            <span>Orders</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/ViewCoupans">
                            <i className="bi bi-envelope"></i>
                            <span>Coupons & Offers</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/Dispute">
                            <i className="bi bi-question-circle"></i>
                            <span>Dispute Managment</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/carmaster">
                            <i className="bi bi-card-list"></i>
                            <span>Car Master</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/service">
                            <i className="bi bi-card-list"></i>
                            <span>Service Master</span>
                        </a>
                    </li>
                       <li className="nav-item">
                        <a className="nav-link collapsed" href="/productcategory">
                            <i className="bi bi-card-list"></i>
                            <span>Product Category</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/checklists">
                            <i className="bi bi-list-check"></i>
                            <span>Checklists</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/testemail">
                            <i className="bi bi-envelope"></i>
                            <span>Test Email</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="pages-error-404.html">
                            <i className="bi bi-dash-circle"></i>
                            <span>General Settings</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="pages-blank.html">

                        </a>
                    </li>

                </ul>

            </aside>

        </div>
        }</div>
    );
};

export default Header;
